import React from "react";

// Navy page header that runs up behind the floating navbar. Shared by the
// inner pages so they open the same way. `overlap` leaves extra room at the
// bottom for the first section of the page to ride up over the header.
function PageHero({ kicker, title, subtitle, overlap = false, children }) {
  return (
    <section className={`page-hero ${overlap ? "page-hero-overlap" : ""}`}>
      <div className="page-hero-inner">
        {kicker && <span className="page-hero-kicker">{kicker}</span>}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
        {children}
      </div>
    </section>
  );
}

export default PageHero;
